import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebaseConfig";
import Loader from "./Loader";

function Login() {
  // ✅ FIX HERE
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const login = async () => {
    setLoading(true);

    if (!email || !password) {
      alert("All fields are required");
      setLoading(false);
      return;
    }

    try {
      const result = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      alert("Login successful");

      localStorage.setItem("user", JSON.stringify(result.user));
      navigate("/");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      {loading && <Loader />}

      <div className="bg-gray-800 px-10 py-10 rounded-xl">
        <h1 className="text-white text-xl mb-4 font-bold text-center">
          Login
        </h1>

        <input
          type="email"
          placeholder="Email"
          className="bg-gray-600 mb-4 px-2 py-2 w-full rounded-lg text-white"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          className="bg-gray-600 mb-4 px-2 py-2 w-full rounded-lg text-white"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          onClick={login}
          className="bg-yellow-500 w-full py-2 rounded-lg font-bold"
        >
          Login
        </button>

        <p className="text-white mt-3 text-center">
          Don't have an account{" "}
          <Link to="/signup" className="text-yellow-400 font-bold">
            Signup
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;